import LocationView from 'text!../locationsAndBuildings/location/location.html';
import BuildingView from 'text!../locationsAndBuildings/building/building.html';

import LocationCtrl from '../locationsAndBuildings/location/locationCtrl';
import BuildingCtrl from '../locationsAndBuildings/building/buildingCtrl';

export default (function () {
    var wizardParentState = 'baseTransactionWizard';

    return {
        location: {
            parent: wizardParentState,
            template: LocationView,
            controller: LocationCtrl,
            params: {
                initialPage: null
            }
        },
        building: {
            parent: wizardParentState,
            template: BuildingView,
            controller: BuildingCtrl,
            params: {
                building: null,
                location: null,
                initialPage: null
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/config/RouteConfig.js
// module id = 1800
// module chunks = 0